<template>
    <div class="static-page">
      Guide Page Content here
    </div>
</template>

<script>

export default {
  name: 'Guide',
  components: {
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
  @import "../style";
</style>
